// features/timesheetSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getCalender,
  getRoadmap,
  getPresentDataBydate,
} from "@/api/new-api/staff-management/time-sheet/time-sheet";

export const fetchCalender = createAsyncThunk(
  "timeSheet/fetchCalender",
  async ({ restaurant_id, query }, { rejectWithValue }) => {
    try {
      const res = await getCalender(restaurant_id, query);
      if (res.status === "success") return res.data;
      return rejectWithValue(res.message || "Failed to fetch calendar");
    } catch (err) {
      return rejectWithValue(err.message || "Something went wrong");
    }
  }
);

export const fetchRoadmap = createAsyncThunk(
  "timeSheet/fetchRoadmap",
  async (restaurant_id, { rejectWithValue }) => {
    try {
      const res = await getRoadmap(restaurant_id);
      if (res.status === "success") return res.data;
      return rejectWithValue(res.message || "Failed to fetch roadmap");
    } catch (err) {
      return rejectWithValue(err.message || "Something went wrong");
    }
  }
);

export const fetchPresentDataByDate = createAsyncThunk(
  "timeSheet/fetchPresentDataByDate",
  async (
    { restaurant_id, date, page = 1, perPage = 10 },
    { rejectWithValue }
  ) => {
    try {
      const res = await getPresentDataBydate(
        restaurant_id,
        date,
        page,
        perPage
      );
      if (res.status === "success") {
        return res.data;
      }
      return rejectWithValue(
        res.message || "Failed to fetch attendance details"
      );
    } catch (err) {
      return rejectWithValue(err.message || "Something went wrong");
    }
  }
);

const initialState = {
  calender: null,
  roadmap: null,
  presentData: null,
  getLoading: false,
  getRoadmapLoadin: false,
  getPresentLoading: false,
  success: null,
  error: null,
};

const timesheetSlice = createSlice({
  name: "timeSheet",
  initialState,
  reducers: {
    clearTimeSheetMessages: (state) => {
      state.success = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCalender.pending, (state) => {
        state.getLoading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(fetchCalender.fulfilled, (state, action) => {
        state.getLoading = false;
        state.calender = action.payload;
        state.success = "Calendar fetched successfully!";
      })
      .addCase(fetchCalender.rejected, (state, action) => {
        state.getLoading = false;
        state.error = action.payload;
        state.calender = null;
      });
    builder
      .addCase(fetchRoadmap.pending, (state) => {
        state.getRoadmapLoadin = true;
        state.error = null;
        state.success = null;
      })
      .addCase(fetchRoadmap.fulfilled, (state, action) => {
        state.getRoadmapLoadin = false;
        state.roadmap = action.payload;
        state.success = "Roadmap fetched successfully!";
      })
      .addCase(fetchRoadmap.rejected, (state, action) => {
        state.getRoadmapLoadin = false;
        state.error = action.payload;
        state.roadmap = null;
      });
    builder
      .addCase(fetchPresentDataByDate.pending, (state) => {
        state.getPresentLoading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(fetchPresentDataByDate.fulfilled, (state, action) => {
        state.getPresentLoading = false;
        state.presentData = action.payload;
        state.success = "Attendance data fetched successfully!";
      })
      .addCase(fetchPresentDataByDate.rejected, (state, action) => {
        state.getPresentLoading = false;
        state.error = action.payload;
        state.presentData = null;
      });
  },
});

export const { clearTimeSheetMessages } = timesheetSlice.actions;
export default timesheetSlice.reducer;
